export const NO_RESULTS_START_TEXT = 'There are no results for your query. Please go';
export const NO_RESULTS_END_TEXT = 'and try another word';
export const BACK_TO_SEARCH = 'Back to search';
